import { VendorCheckEmailPage } from "@/features/vendor-app/pages/VendorCheckEmailPage";
import { createFileRoute } from "@tanstack/react-router";

// Single vendor domain — check-email lives at the root path (no /vendor prefix).
export const Route = createFileRoute("/check-email")({
  validateSearch: (search: Record<string, unknown>): { email?: string } => ({
    email: typeof search.email === "string" ? search.email : undefined,
  }),
  component: VendorCheckEmailPage,
});
